import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { useLocalStorageState } from '../../hooks'

const Wrapper = styled.div`
  height: ${props => props.styleConfig.height};
  color: ${props => props.styleConfig.color};
  background-color: ${props => props.styleConfig.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0 10px;
  cursor: pointer;

  .icon {
    --small-icon-size: 50px;
    height: var(--small-icon-size);
    width: var(--small-icon-size);
    margin: 0 20px;
  }
  .cta {
    font-weight: 400;
    text-decoration: underline;

    &:hover,
    &:focus,
    &:active {
      color: var(--clr-grey-3-to-accent);
    }
  }
  @media (max-width: 768px) {
    font-size: 1rem;
    .icon {
      margin: 0 5px 0 10px;
    }
  }
`

const EmergencyBanner = ({ theme: { getOption }, language, createUserEvent }) => {
  const [config, setConfig] = useState({})
  const [isRead, setIsRead] = useLocalStorageState('isRead', false)

  useEffect(() => {
    const fetchConfig = async () => {
      const configFromCustomerOptions = await getOption('header.emergencyBanner')
      setConfig(configFromCustomerOptions)
    }
    fetchConfig()
  }, [])

  if(!config || !config.showEmergencyBanner || (isRead && config.hideWhenRead)) return null

  const {
    icon,
    height,
    textColor,
    backgroundColor,
    callToActionMessage_English,
    message_English,
    message_Spanish,
    callToActionMessage_Spanish,
    CTA_URL_English,
    CTA_URL_Spanish
  } = config

  const message = language === 'en' ? message_English : message_Spanish

  const callToActionMessage =
    language === 'en'
      ? callToActionMessage_English
      : callToActionMessage_Spanish

  const callToActionUrl = language === 'en' ? CTA_URL_English : CTA_URL_Spanish

  return (
    <Wrapper
      styleConfig={{
        height: height ? height : '100px',
        color: textColor ? textColor : 'var(--clr-black-to-text)',
        backgroundColor
      }}
      role="alert"
    >
      <img src={icon} alt="Emergency icon" className="icon" />
      <p>
        <span className="message">{message} - </span>
        <a
          href={callToActionUrl}
          className="cta"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            createUserEvent({
              category: 'EmergencyBanner',
              data: {
                action: 'click',
                click_location: window.location.href,
                isMobile: window.innerWidth < 768
              }
            })
            setIsRead(true)
          }}
        >
          {callToActionMessage}
        </a>
      </p>
    </Wrapper>
  )
}

EmergencyBanner.propTypes = {
  theme: PropTypes.shape({ getOption: PropTypes.func.isRequired }).isRequired,
  language: PropTypes.string.isRequired,
  createUserEvent: PropTypes.func.isRequired,
}

export default withTheme(EmergencyBanner)



// WEBPACK FOOTER //
// ./src/components/EmergencyBanner/index.js